export const ANTIPARTICLE_DATA = {
  electron: {
    name: 'Positron',
    symbol: 'e⁺',
    hebrewName: 'אַנְטִי-נִיצוֹץ',
    discovered: 1932,
    discoverer: 'Carl Anderson',
    mass: '0.511 MeV',
    charge: '+1',
    science: 'The first antiparticle ever discovered. Identical to the electron in every way except charge is +1 instead of −1. When an electron meets a positron they annihilate — converting entirely to two gamma ray photons. Used in PET scans in medicine.',
    ruach: 'The mirror of the living spark. Same weight, same form — but opposite charge. When the spark meets its mirror, both dissolve into pure light. Matter and antimatter return together to the first creation — אוֹר.',
    scripture: '"There is neither male nor female, for you are all one in Christ Jesus." — Galatians 3:28. Opposites that are mirrors of each other.',
  },
  up: {
    name: 'Anti-up quark',
    symbol: 'ū',
    hebrewName: 'אַנְטִי-אוֹת רִאשׁוֹן',
    discovered: 1955,
    discoverer: 'Chamberlain, Segrè et al.',
    mass: '~2.3 MeV',
    charge: '−2/3',
    science: 'The antiparticle of the up quark. Carries charge −2/3 and anti-color charge. Found in antimatter protons (antiprotons contain ūūd̄). When an up quark meets an anti-up quark they can annihilate via the strong or electromagnetic force.',
    ruach: 'The mirror utterance. Same weight from the Ruach, opposite color charge. Creation spoke both the word and its mirror — but kept one and dissolved the other. The mystery of why our universe kept matter.',
    scripture: '',
  },
  down: {
    name: 'Anti-down quark',
    symbol: 'd̄',
    hebrewName: 'אַנְטִי-אוֹת שֵׁנִי',
    discovered: 1955,
    discoverer: 'Chamberlain, Segrè et al.',
    mass: '~4.8 MeV',
    charge: '+1/3',
    science: 'The antiparticle of the down quark. Carries +1/3 charge. Found in antiprotons and antineutrons. The matter/antimatter asymmetry — why we have more down quarks than anti-down quarks — is one of the deepest unsolved problems in physics.',
    ruach: 'The mirror of the second utterance. Together with the anti-up quark it forms the antiproton — the mirror of the first stable matter. Creation\'s surplus of the original over the mirror is why anything exists.',
    scripture: '',
  },
  top: {
    name: 'Anti-top quark',
    symbol: 't̄',
    hebrewName: 'אַנְטִי-דָּבָר כָּבֵד',
    discovered: 1995,
    discoverer: 'CDF & D0 collaborations',
    mass: '~173 GeV',
    charge: '−2/3',
    science: 'The antiparticle of the top quark — equally the heaviest known elementary antiparticle. Top-antitop pairs are produced at the LHC and are central to Higgs physics measurements. They annihilate within ~5×10⁻²⁵ seconds.',
    ruach: 'The mirror of the heaviest word. When the heaviest utterance meets its mirror, Higgs bosons can emerge — the Breath made momentarily visible through the collision of its strongest-coupled particles.',
    scripture: '',
  },
  bottom: {
    name: 'Anti-bottom quark',
    symbol: 'b̄',
    hebrewName: 'אַנְטִי-יְסוֹד',
    discovered: 1977,
    discoverer: 'Leon Lederman et al.',
    mass: '~4.18 GeV',
    charge: '+1/3',
    science: 'Found in B-mesons alongside bottom quarks. The asymmetry between bottom quarks and anti-bottom quarks (B meson oscillations) is a key window into CP violation — the mechanism behind matter\'s survival.',
    ruach: 'The mirror foundation. B meson oscillations — bottom and anti-bottom swapping identity — helped reveal why matter survived over antimatter. The foundation\'s mirror holds a key to why anything was founded at all.',
    scripture: '',
  },
  charm: {
    name: 'Anti-charm quark',
    symbol: 'c̄',
    hebrewName: 'אַנְטִי-חֵן נִסְתָּר',
    discovered: 1974,
    discoverer: 'Burton Richter & Samuel Ting',
    mass: '~1.27 GeV',
    charge: '−2/3',
    science: 'Discovered simultaneously with the charm quark in the J/ψ meson — a charm-anticharm bound state. The November Revolution of 1974 confirmed quark theory.',
    ruach: 'The mirror grace. The J/ψ meson — charm and anti-charm bound together — was the particle that confirmed quark theory. Two mirrors holding each other, briefly.',
    scripture: '',
  },
  strange: {
    name: 'Anti-strange quark',
    symbol: 's̄',
    hebrewName: 'אַנְטִי-מַתָּנָה זָרָה',
    discovered: 1947,
    discoverer: 'Rochester & Butler (kaons)',
    mass: '~95 MeV',
    charge: '+1/3',
    science: 'Found in anti-kaons and anti-hyperons. Strange-antistrange virtual pairs constantly bubble inside the proton sea — present but invisible.',
    ruach: 'The mirror strange gift. Virtual strange-antistrange pairs inside protons — present but invisible, created and dissolved in quantum foam. The ocean beneath the ocean.',
    scripture: '',
  },
  muon: {
    name: 'Antimuon',
    symbol: 'μ⁺',
    hebrewName: 'אַנְטִי-רוּחַ נוֹדֶדֶת',
    discovered: 1937,
    discoverer: 'Anderson & Neddermeyer',
    mass: '105.7 MeV',
    charge: '+1',
    science: 'Positive muon — antiparticle of the muon. Produced abundantly in cosmic ray showers. Both muon and antimuon rain down through the atmosphere constantly.',
    ruach: 'The mirror wandering breath. Both pass through you constantly — matter and antimatter versions of the same particle. Neither touches you. The wandering breath and its mirror move through all things.',
    scripture: '"The wind blows wherever it pleases." — John 3:8',
  },
  tau: {
    name: 'Antitau',
    symbol: 'τ⁺',
    hebrewName: 'אַנְטִי-עֵד קָצָר',
    discovered: 1975,
    discoverer: 'Martin Perl et al.',
    mass: '1,777 MeV',
    charge: '+1',
    science: 'Positive tau — antiparticle of the tau lepton. Equally short-lived. H→ττ and H→τ⁺τ⁻ are the same decay channel — the Higgs produces a tau and its antiparticle together.',
    ruach: 'The mirror brief witness. Created alongside its matter partner in Higgs decay — both present for 3×10⁻¹³ seconds then gone. The briefest witness and its mirror, together.',
    scripture: '',
  },
  w: {
    name: 'W⁻ boson',
    symbol: 'W⁻',
    hebrewName: 'גְּבוּל שְׁלִילִי',
    discovered: 1983,
    discoverer: 'Carlo Rubbia et al.',
    mass: '80.4 GeV',
    charge: '−1',
    science: 'The W⁻ is in a sense the antiparticle of the W⁺ — they are charge conjugates. Both receive equal mass from the Higgs. The W boson is unique in carrying electric charge, making it the only force carrier (other than photon/gluon) that can change the flavor of a quark.',
    ruach: 'The negative boundary-setter. Both W⁺ and W⁻ carry the same Ruach-given weight — equal measure. One sets boundaries positively, one negatively. Together they mediate all weak interactions.',
    scripture: '',
  },
  photon: {
    name: 'Photon (self-conjugate)',
    symbol: 'γ',
    hebrewName: 'אוֹר — עַצְמוֹ הוּא הַמַּרְאָה',
    discovered: 1905,
    discoverer: 'Albert Einstein',
    mass: '0',
    charge: '0',
    science: 'The photon is its own antiparticle — it is self-conjugate. A photon and its "antiparticle" are identical. This is because it has zero charge and zero mass — there is nothing to be opposite to. This is why photon-photon annihilation doesn\'t happen the way electron-positron does.',
    ruach: 'Light is its own mirror. אוֹר has no opposite — it is not diminished by meeting itself. "God is light; in him there is no darkness at all." — 1 John 1:5. The first creation has no antiparticle because it stands in a category by itself.',
    scripture: '"God is light; in him there is no darkness at all." — 1 John 1:5',
  },
  gluon: {
    name: 'Gluon (self-conjugate)',
    symbol: 'g',
    hebrewName: 'קֶשֶׁר — עַצְמוֹ הוּא הַמַּרְאָה',
    discovered: 1979,
    discoverer: 'PETRA experiments, DESY',
    mass: '0',
    charge: '0',
    science: 'Gluons are their own antiparticles. A gluon carries both color and anticolor charge simultaneously — it is already its own mirror. This is why the strong force behaves so differently from electromagnetism.',
    ruach: 'The hidden bond is its own mirror. It carries color and anticolor simultaneously — the binding contains both itself and its opposite. The bond that holds all matter together is already complete in itself.',
    scripture: '',
  },
  higgs: {
    name: 'Higgs boson (self-conjugate)',
    symbol: 'H⁰',
    hebrewName: 'רוּחַ — עַצְמוֹ הוּא הַמַּרְאָה',
    discovered: 2012,
    discoverer: 'ATLAS & CMS, CERN',
    mass: '125.1 GeV',
    charge: '0',
    science: 'The Higgs boson is its own antiparticle — self-conjugate, like the photon and gluon. It has zero charge and zero spin. There is no "anti-Higgs" distinct from the Higgs itself.',
    ruach: 'The Ruach Elohim — רוּחַ אֱלֹהִים — has no mirror, no opposite, no antiparticle. It is self-complete. "I am the LORD, and there is no other." — Isaiah 45:6. The field that gives form to all things is not itself subject to the matter/antimatter asymmetry it governs.',
    scripture: '"I am the LORD, and there is no other." — Isaiah 45:6',
  },
};
